import { useQuery } from '@tanstack/react-query';
import { dashboardRepository, type DashboardRange } from '../repository';
import { queryKeys } from '@/lib/api/queryKeys';

export function useDashboardSummary(range: DashboardRange = 'today') {
  return useQuery({
    queryKey: queryKeys.dashboard.summary(range),
    queryFn: () => dashboardRepository.summary(range),
    refetchInterval: () => (typeof navigator !== 'undefined' && !navigator.onLine ? false : 60_000),
    placeholderData: (prev) => prev,
  });
}
